import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import PreviewIcon from '@mui/icons-material/Preview';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteStudentSale } from '../../Store/PHPSlice/stockApi';
import 'react-toastify/dist/ReactToastify.css';
import '../../Static/Master/firmtable.css';

const TableBody4 = ({
  serialNumber,
  id,
  dt,
  billNo,
  zoneNm,
  schlNm,
  studNm,
  totissqty,
  totamt,
  selected,
  sts = '0', // default to pending
  handleClick,
}) => {
  const dispatch = useDispatch();

  const handleEditClick = () => {
    window.open(
      `/student-sale-edit/${id}`,
      '_blank',
      'width=800,height=600,scrollbars=yes,resizable=yes'
    );
  };

  const handleAddClick = () => {
    window.open(
      `/student-sale-add/${id}`,
      '_blank',
      'width=1000,height=700,scrollbars=yes,resizable=yes'
    );
  };

  const handleDeleteClick = () => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this Item?'
    );
    if (isConfirmed) {
      dispatch(deleteStudentSale(id))
        .then(() => {
          alert('Student Sale Invoice Deleted Successfully....!!!');
          window.location.reload();
        })
        .catch((err) => {
          console.error('Error deleting item:', err);
          toast.error('Failed to delete Item');
        });
    }
  };

  const handleViewClick = () => {
    window.open(
      `/student-sale-print/${id}`,
      '_blank',
      'width=1000,height=700,scrollbars=yes,resizable=yes'
    );
  };

  return (
    <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {serialNumber}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {dt}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {billNo}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {zoneNm || '-'}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {schlNm || '-'}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {studNm}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {totissqty}
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {totamt}
      </TableCell>
      {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        {sts === '1' ? (
          <span style={{ color: 'green' }}>UPDATED</span>
        ) : (
          <span style={{ color: 'red' }}>PENDING</span>
        )}
      </TableCell>*/}
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center"> 
        <PreviewIcon onClick={handleViewClick} className="cursor-pointer" />
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        <EditIcon
          className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`}
          onClick={handleEditClick}
        />
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        <AddCircleIcon
          className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`}
          onClick={handleAddClick}
        />
      </TableCell>
      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
        <DeleteIcon
          className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`}
          onClick={handleDeleteClick}
        />
      </TableCell>
    </TableRow>
  );
};

export default TableBody4;
